module.exports = __webpack_public_path__ + "img/order_plate_black.9e43f6d0.svg";